<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="tw-w-full">
          <div class="row tw-h-full">
            <!-- requestDetail -->
            <section class="md:tw-w-full !tw-mt-3">
              <fieldset>
                <legend class="tw-flex-center tw-py-2">
                  <i class="mdi mdi-message-cog tw-ml-2 mdi-24px"></i>
                  {{ pageVocabs + "legends.requestDetail" | translate }}
                </legend>

                <div class="row">
                  <div class="md:tw-w-1/2">
                    <div class="row">
                      <!-- userName -->

                      <div class="md:tw-w-1/2 tw-my-1">
                        <list-group-item
                          [label]="'common.userName' | translate"
                          [value]="whiteMsgDetail.userName"
                        >
                        </list-group-item>
                      </div>

                      <!-- title -->

                      <div class="md:tw-w-1/2 tw-my-1">
                        <list-group-item
                          [label]="'common.title' | translate"
                          [value]="whiteMsgDetail.title"
                        >
                        </list-group-item>
                      </div>

                      <!-- phonebook -->
                      <div class="tw-w-full tw-my-2">
                        <div
                          class="tw-border tw-border-gray-100 dark:tw-border-dark-100 tw-rounded-md tw-flex tw-justify-start flex-column"
                        >
                          <div
                            class="tw-rounded tw-flex tw-justify-start tw-items-center dark:tw-bg-dark-300 tw-bg-gray-100 tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
                          >
                            <i class="mdi mdi-card-account-phone mdi-22px"></i
                            ><span
                              class="tw-text-gray-800 dark:tw-text-gray-300 tw-mx-3 tw-font-medium"
                              >{{ "common.phonebook" | translate }}
                            </span>
                          </div>

                          <div class="scroll-div tw-p-3 tw-px-5">
                            <div class="row">
                              <!-- phonebookItem -->
                              <div
                                class="md:tw-w-1/2 2xl:tw-w-1/3 tw-my-1"
                                *ngFor="let item of whiteMsgDetail.phonebooks"
                              >
                                <div
                                  class="list-group-item tw-flex tw-justify-between tw-items-center tw-py-4 bg-light tw-border dark:tw-border-dark-100 tw-rounded-md"
                                >
                                  <span
                                    class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
                                  >
                                    {{ item.name }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="md:tw-w-1/2">
                    <div class="row">
                      <!-- enterSms -->
                      <div class="sm:tw-w-1/2 tw-my-2">
                        <div
                          class="border border-secondary rounded tw-flex tw-justify-start flex-column"
                        >
                          <div
                            class="tw-flex tw-justify-start tw-items-center bg-light-dark tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
                          >
                            <i
                              class="mdi mdi-location-enter mdi-22px text-success tw-ml-1"
                            ></i
                            ><span
                              class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
                              >{{ fields + "enterSms" | translate }}
                            </span>
                          </div>
                          <div
                            class="tw-font-medium tw-p-5 tw-text-gray-600 dark:tw-text-gray-300 scroll-text"
                          >
                            {{ whiteMsgDetail?.enterSms }}
                          </div>
                        </div>
                      </div>

                      <!-- exitSms -->
                      <div class="sm:tw-w-1/2 tw-my-2">
                        <div
                          class="border border-secondary rounded tw-flex tw-justify-start flex-column"
                        >
                          <div
                            class="tw-flex tw-justify-start tw-items-center bg-light-dark tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
                          >
                            <i
                              class="mdi mdi-location-exit mdi-22px text-danger tw-ml-1"
                            ></i
                            ><span
                              class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
                              >{{ fields + "exitSms" | translate }}
                            </span>
                          </div>
                          <div
                            class="tw-font-medium tw-p-5 tw-text-gray-600 dark:tw-text-gray-300 scroll-text"
                          >
                            {{ whiteMsgDetail?.exitSms }}
                          </div>
                        </div>
                      </div>

                      <!-- returnText -->
                      <div class="sm:tw-w-1/2 tw-my-2">
                        <div
                          class="border border-secondary rounded tw-flex tw-justify-start flex-column"
                        >
                          <div
                            class="tw-flex tw-justify-start tw-items-center bg-light-dark tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
                          >
                            <i
                              class="mdi mdi-keyboard-return mdi-22px text-blue tw-ml-1"
                            ></i
                            ><span
                              class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
                              >{{ fields + "returnText" | translate }}
                            </span>
                          </div>
                          <div
                            class="tw-font-medium tw-p-5 tw-text-gray-600 dark:tw-text-gray-300 scroll-text"
                          >
                            {{ whiteMsgDetail?.returnText }}
                          </div>
                        </div>
                      </div>

                      <!-- cancelText -->
                      <div class="sm:tw-w-1/2 tw-my-2">
                        <div
                          class="border border-secondary rounded tw-flex tw-justify-start flex-column"
                        >
                          <div
                            class="tw-flex tw-justify-start tw-items-center bg-light-dark tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
                          >
                            <i
                              class="mdi mdi-cancel mdi-22px text-danger tw-ml-1"
                            ></i
                            ><span
                              class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
                              >{{ fields + "cancelText" | translate }}
                            </span>
                          </div>
                          <div
                            class="tw-font-medium tw-p-5 tw-text-gray-600 dark:tw-text-gray-300 scroll-text"
                          >
                            {{ whiteMsgDetail?.cancelText }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </section>

            <!-- define Scenario -->
            <section class="md:tw-w-full !tw-mt-3 tw-h-full">
              <fieldset>
                <legend class="tw-flex-center tw-py-2 tw-h-full">
                  <i class="mdi mdi-table-cog tw-ml-2 mdi-24px"></i>
                  {{ pageVocabs + "legends.defineScenario" | translate }}
                </legend>

                <div class="row">
                  <!-- status -->
                  <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                    <enum-select-search
                      class="tw-w-full"
                      enumName="WhiteMessageStatus"
                      [control]="form?.get('status')"
                      [label]="fields + 'status'"
                      [value]="whiteMsgDetail.status"
                      (valueChange)="
                        whiteMsgDetail.status = $event; changeValidation()
                      "
                      (onError)="onClose()"
                    >
                    </enum-select-search>
                  </div>

                  <ng-container
                    *ngIf="
                      whiteMsgDetail.status == WhiteMessageStatus.Confirmed
                    "
                  >
                    <!-- privateNumberId -->
                    <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                      <private-number-select-search
                        [sendType]="SendTypes.Club"
                        [control]="form?.get('privateNumberId')"
                        [(value)]="whiteMsgDetail.privateNumberId"
                        (onError)="onClose()"
                      >
                      </private-number-select-search>
                    </div>

                    <!-- dailyAddLimit -->
                    <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                      <form-field
                        [(value)]="whiteMsgDetail.dailyAddLimit"
                        type="tel"
                        [hasNumberSeparator]="true"
                        [control]="form?.get('dailyAddLimit')"
                        [label]="fields + 'dailyAddLimit'"
                      >
                      </form-field>
                    </div>

                    <!-- monthlyAddLimit -->
                    <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                      <form-field
                        type="tel"
                        [hasNumberSeparator]="true"
                        [control]="form?.get('monthlyAddLimit')"
                        [(value)]="whiteMsgDetail.monthlyAddLimit"
                        [label]="fields + 'monthlyAddLimit'"
                      >
                      </form-field>
                    </div>

                    <!-- repeatTextDay -->
                    <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                      <form-field
                        [(value)]="whiteMsgDetail.repeatTextDay"
                        [label]="fields + 'repeatTextDay'"
                        type="tel"
                        [hasNumberSeparator]="true"
                        [control]="form?.get('repeatTextDay')"
                      >
                      </form-field>
                    </div>

                    <!-- isSendCancelText -->
                    <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                      <mat-slide-toggle
                        formControlName="isSendCancelText"
                        class="tw-mt-3"
                        [(ngModel)]="whiteMsgDetail.isSendCancelText"
                      >
                        {{ fields + "isSendCancelText" | translate }}
                      </mat-slide-toggle>
                    </div>
                  </ng-container>

                  <!-- rejectComment -->
                  <div
                    class="md:tw-w-full lg:tw-w-1/2"
                    *ngIf="whiteMsgDetail.status == WhiteMessageStatus.Reject"
                  >
                    <form-textarea
                      class="tw-w-full"
                      [label]="fields + 'rejectComment'"
                      [(value)]="whiteMsgDetail.rejectComment"
                      [control]="form?.get('rejectComment')"
                      [rows]="4"
                    >
                    </form-textarea>
                  </div>
                </div>
              </fieldset>
            </section>
          </div>
        </div>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
